export default __webpack_public_path__ + "static/cover-c121deb648c7c7c3fa9b96b3c772e9da.gif";